export const ENUMS_NAMESPACE = 'enums';

// mutations
export const SET_ENUMS = 'setEnums';

// actions
export const GET_ENUMS = 'getEnums';

export default {};
